import { RectRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathPickerContribution, MathRectPicker } from "../constants";

import { DefaultMathRectPicker } from "./rect-picker";

let loadRectPick = !1;

export function bindRectMathPickerContribution(container) {
    loadRectPick || (loadRectPick = !0, container.bind(MathRectPicker).toDynamicValue((() => new DefaultMathRectPicker(resolveContainerBinding(container, RectRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathRectPicker));
}
//# sourceMappingURL=rect-module.js.map
